import { Injectable } from "@angular/core";
import {
  ICalendarEvent,
  IEventLocation,
  RRULE,
  IUIEvent,
} from "../models/calendar.model";
import { CalendarError, ICalendarError } from '../models/error.model';

declare const gapi;

@Injectable({
  providedIn: "root",
})
export class CalendarService {
  private calendar_id: string;
  private calendarApi: any;
  initClient() {
    gapi.load("client:auth2", () => {
      // console.log("client loaded");
      gapi.client.init({
        apiKey: "AIzaSyDxuLw8AFNGTOS9mDzRHitn2m74yoZbP8M",
        clientId:
          "110175057637-rsgb93qgn8dnrobjbl05hmp78bidk71j.apps.googleusercontent.com",
        discoveryDocs: [
          "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
        ],
        scope: "https://www.googleapis.com/auth/calendar",
      });

      // gapi.client.load("calendar", "v3", () => console.log("calendar loaded!"));
      gapi.client.load("calendar", "v3", async () => {
        this.calendarApi = await gapi.client.calendar;
      });
    });
  }

  async loadCalendar() {
    //have to check if google loggin user is the same one who logged in with firebase auth,

    //TODO: check current user

    //get calendar that they only the owner role

    // const calendars = await gapi.client.calendar;
    const calendarsList = await this.calendarApi.calendarList.list({
      maxResults: 10,
      minAccessRole: "owner",
    });
    //parse the json string to be the object
    const result = JSON.parse(calendarsList.body);
    // console.log("result Items =>", result);
    //list out only the calendarList items and cast it type to Array
    const items = result["items"] as Array<any>;
    // console.log("calendar item =>", items);
    // console.log("length", items.length);
    //check if the existing name of calendar
    const isEmpty = items.filter((c) => c["summary"] == "homemadeAppCalendar");
    // console.log("isEmpty => ", isEmpty);
    //found that not empty so it confilted on name,
    if (isEmpty.length == 0) {
      //isEmpty means no conflited, so try to create new calendar named 'myCalendar'
      try {
        console.log("loading...");
        let newCalendar = await this.calendarApi.calendars.insert({
          resource: {
            summary: "homemadeAppCalendar",
          },
        });
        // console.log(`api result status code: ${newCalendar.status}`);
        // console.log("new calendar", newCalendar.result);
        // console.log("calendar created successfully");
        // console.log(`calendarId: ${newCalendar.result.id}`);
        this.calendar_id = newCalendar.result.id;
        // console.log(`created Name: ${newCalendar.result.summary}`);
      } catch (e) {
        console.log(e.message);
      }
    } else {
      // console.log("calendar has been conflit on name");
      // console.log("trying to get the existing calendar");
      // //TODO: get the calendar from existing name
      // console.log("current calendar ID:", isEmpty[0].id);
      this.calendar_id = isEmpty[0].id;
    }
    //search for the summary named 'mycalendar' if isEmpty() try to create one
    // const isEmpty = resultItems.filter(c => c['summary'] != 'mycalendar');
    // console.log('isEmpty => ', isEmpty);
  }
  async createNewCalendar(name: string) {
    const newCalendarResponse = await this.calendarApi.calendars.insert({
      resource: {
        summary: name,
      }
    });
    //TODO: ทำให้ข้อมูลการสร้างเอาไปใช้งานได้
  }
  async createEvent(ev: ICalendarEvent): Promise<ICalendarError | ICalendarEvent> {
    // console.log(`calendar id: ${this.calendar_id}`);
    // console.log('event', ev);
    try{
      const response = await gapi.client.calendar.events.insert({
        calendarId: this.calendar_id,
        resource: ev,
      });
      return response;
    } catch (error) {
      return error as ICalendarError;
    }
    // console.log("event response", response);
  }

  async loadEvents() {
    // console.log("loading event..");
    if (this.calendar_id == null) {
      await this.loadCalendar();
    }
    const { body } = await gapi.client.calendar.events.list({
      calendarId: this.calendar_id,
      maxResults: 100,
    });
    // console.log("response body", body);
    const { items } = JSON.parse(body);
    // console.log("events items", items);
    const events = this.toUIevents(items);
    const filterOutRecurrence = events.filter((item) => {
      return item.recurrence == null;
    });
    // console.log("filter out recurring event", filterOutRecurrence);
    // console.log("mapped event", events);
    const recurringEvents = await this.loadRecurringEvent(events);
    // console.log("recurring result", typeof result);
    const concatinateEvents = filterOutRecurrence.concat(recurringEvents);
    // console.log('result', concatinateEvents);
    return concatinateEvents;
  }

  async loadRecurringEvent(mainEvent) {
    let merged: Array<any> = [];
    const recurringItems = mainEvent.map(async (ev) => {
      const { body } = await gapi.client.calendar.events.instances({
        calendarId: this.calendar_id,
        eventId: ev.eventId,
      });
      const { items } = JSON.parse(body);
      return items;
    });
    // console.log("recurring id", recurringItems);
    const apiResults = await Promise.all(recurringItems);
    merged = [].concat.apply([], apiResults);
    const recurringEventsResults = this.toUIevents(merged);
    // console.log("recurring events", recurringEventsResults);
    return recurringEventsResults;
  }

  rruleToString(rrule: RRULE): string {
    const fullRrule: string = `RRULE:FREQ=${rrule.freq};${rrule.mode}=${rrule.interval};COUNT=${rrule.count}`;
    return fullRrule;
  }

  private toUIevents(events: Array<ICalendarEvent>): Array<IUIEvent> {
    return events.map((event) => {
      let locationInfo = this.getInfoFromLocationString(event.location);
      const setEndTime = new Date(event.start.date);
      return <IUIEvent>{
        summary: event.summary,
        start: event.start,
        end: event.start,
        title: `[แปลงที่ ${locationInfo.room}-(${locationInfo.crop})]-${event.summary}`,
        startTime: new Date(event.start.date),
        endTime: new Date(setEndTime.setDate(setEndTime.getDate() + 1)),
        allDay: true,
        crop: locationInfo.crop,
        room: locationInfo.room,
        cropId: locationInfo.cropId,
        eventId: event.id,
        recurrence: event.recurrence,
        description: event.description,
      };
    });
  }

  getInfoFromLocationString(str: string): IEventLocation {
    if (str != null || str !== undefined) {
      let split: Array<string> = str.split(".");
      // console.log("splitted str", split);
      return <IEventLocation>{
        room: split[0],
        crop: split[1],
        cropId: split[2],
      };
    } else {
      return null;
    }
  }

  getInfoToLocationString(eventLocation: IEventLocation): string {
    if(eventLocation != null) {
      return`${eventLocation.room}."${eventLocation.crop}.${eventLocation.cropId}`;
    } else {
      null;
    }
  }

  getIdFromRecurringEvent = (eventId: string) => eventId.split("_")[0];

  async deleteEvent(eventId: string): Promise<boolean> {
    await gapi.client.calendar.events.delete({
      calendarId: this.calendar_id,
      eventId: this.getIdFromRecurringEvent(eventId),
    }, async (err) => {
      return false;
    });
    return true;
  }

  async patchEvent(eventId: string, event: Partial<ICalendarEvent>): Promise<boolean> {
    console.log('patching event', event);
    try{
      await gapi.client.calendar.events.patch({
        calendarId: this.calendar_id,
        eventId: this.getIdFromRecurringEvent(eventId),
        resource: event,
      }, async (err) => {
        return false;
      });
      return true;
    } catch (err) {
      return false;
    }
  }
}
